import { Fragment, ReactNode } from "react";
import editorJSHTML from "editorjs-html";
import { Interweave } from "interweave";
import { UrlMatcher } from "interweave-autolink";

import { interweaveTransform } from "utils/htmlUtils";
import { renderArticleContent } from "utils/articleUtils";

interface FullArticleProps {
  articleContent?: string;
  articleTitle?: string;
}

function FullArticle({ articleContent, articleTitle }: FullArticleProps) {
  return (
    <div className="relative">
      <div className=" flex h-fit w-full flex-col overflow-hidden lg:p-5 ">
        {articleTitle ? (
          <div className="mb-5 text-xl font-bold">{articleTitle}</div>
        ) : null}
        <article className="prose">
          {renderArticleContent(articleContent)}
        </article>
      </div>
    </div>
  );
}

export default FullArticle;
